<script>
  import Header from "../components/Header.svelte";
  import Footer from "../components/Footer.svelte";
</script>

<Header />

<h1 class="text-xl text-white font-black">Imprint</h1>
<Footer />

<style></style>
